import React from 'react';

import { ListWidgetPropertiesSetting } from '@lumapps/designer-widget-settings/components/ListWidgetPropertiesSetting';
import {
    ListWidgetProperties,
    SELECTION_TYPE_VALUES,
    SelectionSettingType,
} from '@lumapps/designer-widget-settings/types';
import { Divider } from '@lumapps/lumx/react';

import { DATA_SCOPE } from '../../constants';
import { TrainingListPropertiesType } from '../../types';
import { SelectionSection } from './SelectionSection';

import './index.scss';

export interface TrainingListSettingsProps {
    properties?: TrainingListPropertiesType;
    onChange: (properties: TrainingListPropertiesType) => void;
}

const CLASSNAME = 'training-list-settings';

export const TrainingListSettings: React.FC<TrainingListSettingsProps> = ({ properties, onChange }) => {
    const computedSelection: SelectionSettingType = React.useMemo(() => {
        if (properties?.displayType === 'pick') {
            return {
                selectedOption: SELECTION_TYPE_VALUES.MANUAL,
                selectedEntitiesIds: properties?.learningObjectIds,
            };
        }

        return {};
    }, [properties]);

    return (
        <div className={CLASSNAME}>
            <SelectionSection
                onChange={({ selection }) => {
                    if (selection.selectedOption === SELECTION_TYPE_VALUES.MANUAL) {
                        onChange({
                            learningObjectIds: selection.selectedEntitiesIds,
                            displayType: 'pick',
                        });
                    }
                }}
                currentSelection={computedSelection}
            />
            <Divider />
            <ListWidgetPropertiesSetting
                onChange={(input) =>
                    onChange({
                        maxNumber: input?.maxNumber,
                        canLoadMore: input?.canLoadMore,
                    })
                }
                currentPropertiesSetting={{
                    canLoadMore: properties?.canLoadMore ?? true,
                    hasFilters: false,
                    maxNumber: properties?.maxNumber,
                }}
                defaultMaxNumber="3"
                dataScope={DATA_SCOPE}
                propertiesToDisplay={[ListWidgetProperties.maxNumber, ListWidgetProperties.loadMore]}
            />
        </div>
    );
};
